import { $api } from "../../../../services/request.config";
import {
    setCurrentDocumentAction,
    unsetCurrentDocumentAction,
} from "../../CurrentRequest/setCurrentDocument.action";

import IndividualCoefficientsService from "../../../../../frontend.services/LeaderRequests/IndividualCoefficientsService";

const IC_ENTITY_TYPE = { code: "individual-coefficients", name: "Установление индивидуальных коэффициентов" };

// GET /api/v1/managers/requests/individual-coefficients/{uid}
// Грузит заявку для карточки в разделе "Документы" (просмотр + удаление черновика).
// Кладёт данные в state.requests.singleDocument тем же экшеном, что local-trip и leave-заявки,
// чтобы UserRequestCard отрисовал модалку. По образцу getLocalTripDetailThunk.
export const getIndividualCoefficientCardThunkAction = (uid, props = {}) => async (dispatch) => {
    try {
        const response = await $api(`v1/managers/requests/individual-coefficients/${uid}`);

        if (!IndividualCoefficientsService.isValidRequestResponse(response.data, uid)) {
            dispatch(unsetCurrentDocumentAction());
            props.setDescription && props.setDescription(
                "Не удалось загрузить информацию по заявке. Пожалуйста, повторите попытку позже.",
            );
            return;
        }

        // Как и в setCurrentRequestThunkAction — просмотр карточки в "Моих заявках" отмечает заявку
        // прочитанной (снимает полужирное выделение в списке). Вызывается только когда caller явно
        // просит об этом (props.markReviewed) — в очереди согласования руководителя /review не дёргается
        // ни для одного типа заявок, поведение там не трогаем. Если уже прочитана — не дёргаем повторно.
        if (props.markReviewed && !props.isReviewed) {
            await $api.post(`v1/leaverequest/${uid}/review`);
        }

        const data = response.data;

        const currentRequestCard = {
            "Наименование": IC_ENTITY_TYPE.name,
            "Мероприятие": data.eventName || "...",
            "Статус": data.status || "...",
        };
        if (data.departmentName) {
            currentRequestCard["Структурное подразделение"] = data.departmentName;
        }

        dispatch(setCurrentDocumentAction({
            currentRequestCard,
            currentRequest: {
                ...data,
                // маркер для роутинга модалки в UserRequestCard и защита SwitchRequests в режиме руководителя
                requestTypeId: 22,
                entityType: data.entityType || IC_ENTITY_TYPE,
            },
        }));
    } catch (error) {
        dispatch(unsetCurrentDocumentAction());
        props.setDescription && props.setDescription(
            "Не удалось загрузить информацию по заявке. Пожалуйста, повторите попытку позже.",
        );
    }
};
